// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1wyQd","content":"GlobalSearch_content__HDQyp"};